import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { PageLoader, EmptyState } from "@/components/Loading";
import { StatusBadge } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Check, X, Mail, Phone } from "lucide-react";
import { toast } from "sonner";

export default function SupervisorRequests() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/supervisor-requests").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const act = async (id, status) => {
    try { await api.put(`/supervisor-requests/${id}`, { status }); toast.success("تم التحديث"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (rows === null) return <PageLoader />;

  return (
    <>
      <PageHeader title="طلبات الإشراف" subtitle="مراجعة طلبات الحصول على صلاحية مشرف والموافقة عليها" />
      {rows.length === 0 ? <EmptyState icon={ShieldCheck} title="لا توجد طلبات إشراف" /> : (
        <div className="stagger grid gap-4">
          {rows.map((r) => (
            <div key={r.id} data-testid={`sup-req-${r.id}`} className="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-100 bg-card p-5 soft-shadow">
              <div>
                <div className="flex items-center gap-3">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy text-sm font-bold text-gold">{r.name?.charAt(0)}</div>
                  <div>
                    <p className="font-heading font-bold text-navy">{r.name}</p>
                    <div className="mt-1 flex flex-wrap gap-3 text-xs text-slate-400">
                      <span className="flex items-center gap-1"><Mail className="h-3.5 w-3.5" /> {r.email}</span>
                      <span className="flex items-center gap-1"><Phone className="h-3.5 w-3.5" /> {r.phone || "—"}</span>
                      <span>{new Date(r.created_at).toLocaleDateString("ar")}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <StatusBadge status={r.status} />
                {r.status === "pending" && (
                  <>
                    <Button data-testid={`sup-approve-${r.id}`} onClick={() => act(r.id, "approved")} size="sm" className="rounded-lg bg-emerald-600 hover:bg-emerald-700"><Check className="me-1 h-4 w-4" /> قبول</Button>
                    <Button data-testid={`sup-reject-${r.id}`} onClick={() => act(r.id, "rejected")} size="sm" variant="outline" className="rounded-lg border-red-200 text-red-500"><X className="me-1 h-4 w-4" /> رفض</Button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
